import { AnalyticsAttributes, AnalyticsDestination } from './destination';

export class AnalyticsDispatcher<Event, Options = undefined> {
  constructor(private readonly destinations: Array<AnalyticsDestination<Event, Options>>) {}

  public dispatch(event: Event, attributes: AnalyticsAttributes, options?: Options): void {
    this.destinations.forEach(destination => destination.deliver(event, attributes, options));
  }
}
